import MainContentGrid from './MainContentGrid';

export default MainContentGrid;